import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { videoUplaodEndpoints } from "../apis";

const { POST_VIDEO_UPLOAD_API } = videoUplaodEndpoints;

// Upload Video to aws API call directly
export async function uploadVideo(formData) {
  //console.log("Uploading Data:", formData);

  const toastId = toast.loading("Uploading video...");
  const token = JSON.parse(localStorage.getItem("token"));

  try {
    await apiConnector(
      "POST",
      POST_VIDEO_UPLOAD_API,
      formData,
      {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      }
    );

    toast.success("Video uploaded successfully!");
    //return response.data;
  } catch (error) {
    //console.error("VIDEO UPLOAD ERROR:", error);
    toast.error("Failed to upload video");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}


//  Get All Videos (optional)
// export function getAllVideos() {
//   return async () => {
//     const token = JSON.parse(localStorage.getItem("token"));

//     try {
//       const response = await apiConnector("GET", GET_ALL_VIDEOS_API, null, {
//         Authorization: `Bearer ${token}`,
//       });

//       return response.data;
//     } catch (error) {
//       console.error("GET VIDEOS ERROR:", error);
//       toast.error("Failed to load videos");
//       return [];
//     }
//   };
// }
